<template>
  <div id="EventList">
    <!-- Content Header -->
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1 class="m-0 text-dark">網誌列表</h1>
          </div>
          <!-- /.col -->
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item active">網誌列表</li>
            </ol>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
    </div>
    <!-- /.Content Header -->

    <!-- Main content -->
    <div id="event" class="content">
      <div class="container-fluid">
        <div class="row mb-3">
          <div class="col-3">
            <div class="filter">
              <el-date-picker
                v-model="SGL_AddTimerDate"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="col-2">
            <el-input
              v-model="SGL_DisplayName"
              clearable
              placeholder="编辑员"
            ></el-input>
          </div>
          <!-- <div class="col-7 d-flex justify-content-end">
            <button
              type="button"
              class="btn btn-block btn-primary btn-sm"
              style="width: 150px"
              @click="stop()"
            >
              <i class="nav-icon fas fa-plus fa-sm mr-1"></i> 停權網誌用戶
            </button>
          </div> -->
        </div>
        <div class="row mb-2">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <el-table
                  :data="EventListModel"
                  :stripe="true"
                  row-key="id"
                  border
                >
                  <el-table-column
                    label="發布日期"
                    align="center"
                    prop="sgL_CreateTimeS"
                  ></el-table-column>
                  <el-table-column
                    label="團名稱"
                    align="center"
                    prop="sgL_BlogName"
                  >
                    <template slot-scope="scope">
                      <span class="ck" @click="go1(scope.row)">
                        {{ scope.row.sgL_BlogName }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column label="标题" align="center" prop="sgL_Title">
                    <template slot-scope="scope">
                      <span class="ck" @click="go2(scope.row.id)">
                        {{ scope.row.sgL_Title }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="编辑员"
                    align="center"
                    prop="sgL_UsersName"
                  ></el-table-column>
                  <el-table-column
                    label="订阅量"
                    align="center"
                    prop="sgL_SubscribeCount"
                  ></el-table-column>
                  <el-table-column
                    label="订阅浏览"
                    align="center"
                    prop="sgL_ViewCount"
                  ></el-table-column>
                  <el-table-column
                    label="浏览量"
                    align="center"
                    prop="sgL_ViewCount"
                  >
                  </el-table-column>
                  <el-table-column label="操作" width="350">
                    <template slot-scope="scope">
                      <el-button
                        type="success"
                        size="mini"
                        @click="show(scope.row.id)"
                        v-if="scope.row.sgL_IsShow"
                        >隱藏</el-button
                      >
                      <el-button
                        type="success"
                        size="mini"
                        @click="show(scope.row.id)"
                        v-else
                        >公開</el-button
                      >
                      <el-button
                        type="primary"
                        size="mini"
                        @click="edit(scope.row.id)"
                        >編輯</el-button
                      >
                      <el-button
                        type="danger"
                        size="mini"
                        @click="DeleteEvent(scope.row.id)"
                        >刪除</el-button
                      >
                      <el-button
                        type="danger"
                        size="mini"
                        @click="stop(scope.row)"
                        >停權此用戶</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="row">
                <div class="col-lg-4 offset-lg-7">
                  <!--  引用分页组件 -->
                  <pagination
                    v-if="pageParams.pageshow"
                    :currentPage="pageParams.currentPage"
                    :total="pageParams.total"
                    :limit="pageParams.limit"
                    :small="true"
                    @handleCurrentChange="handleCurrentChange"
                    @handleSizeChange="handleSizeChange"
                  />
                </div>
              </div>
              <!-- /.card-body -->
            </div>
          </div>
          <!-- /.col-12 -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.Container Fluid -->
      <!-- Modal: 篩選條件 -->
      <el-dialog title="操作" :visible.sync="dialogVisible" width="40%">
        <div>
          <!-- <div>搜索用戶</div> -->
          <div class="d-flex">
            <el-button @click="addFengjing">新增</el-button>
          </div>
          <div>
            <el-table :data="table2" :stripe="true" row-key="id" border>
              <el-table-column
                label="停權時間"
                align="center"
                prop="sgL_StartTimeF"
              ></el-table-column>
              <el-table-column
                label="解封時間"
                align="center"
                prop="sgL_EndTimeF"
              ></el-table-column>
              <el-table-column
                label="名稱"
                align="center"
                prop="sgL_DisplayName"
              >
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <div class="d-flex">
                    <el-select
                      @change="stopChange($event, scope.row)"
                      placeholder="请选择"
                      v-model="scope.row.stop"
                    >
                      <el-option
                        v-for="item in tb2Sdlist"
                        :key="item.type"
                        :label="item.name"
                        :value="item.type"
                      >
                      </el-option>
                    </el-select>
                    <el-button
                      type="success"
                      size="mini"
                      @click="stopOp(scope.row)"
                      >停權</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div>
            <pagination
              :currentPage="pageParams2.currentPage"
              :total="pageParams2.total"
              :limit="pageParams2.limit"
              :small="true"
              @handleCurrentChange="handleCurrentChange2"
              @handleSizeChange="handleSizeChange2"
            />
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <!-- /.modal: 篩選條件 -->
    </div>
    <!-- /.Content -->
  </div>
</template>
<script>
import { Message } from "element-ui";
import pagination from "../common/Page";
import moment from "moment";
export default {
  data() {
    return {
      SGL_DisplayName: "",
      dialogVisible: false,
      SGL_AddTimerDate: null,
      EventList: null,
      EventStatusList: null,
      RemarkList: null,
      EventCityList: null,
      EventRemarkList: null,
      EventAreaList: null,
      EventTypeList: null,
      fengjingItem: null,
      //分页
      pageParams: {
        currentPage: 1,
        limit: 20,
        total: 0,
        pageshow: true,
      },
      pageParams2: {
        currentPage: 1,
        limit: 10,
        total: 0,
        pageshow: true,
      },
      filterParam: {
        title: null,
        country: null,
        type: null,
        activeDate: null,
        area: null,
        status: null,
        remark: null,
        ApplyDate: null,
        Quarter: 0,
      },
      table2: [],
      tb2SdValue: "",
      tb2Sdlist: [
        {
          type: 1,
          name: "3天",
        },
        {
          type: 2,
          name: "5天",
        },
        {
          type: 3,
          name: "7天",
        },
        {
          type: 4,
          name: "14天",
        },
        {
          type: 5,
          name: "無限",
        },
        {
          type: 6,
          name: "解除",
        },
      ],
    };
  },
  components: {
    pagination,
  },
  watch: {
    SGL_AddTimerDate: {
      handler: function (newval, oldval) {
        this.handleCurrentChange(1);
      },
    },
    SGL_DisplayName: {
      handler: function (newval, oldval) {
        this.handleCurrentChange(1);
      },
    },
  },
  created() {
    this.GetEventList();
  },
  methods: {
    addFengjing() {
      if (!this.table2.filter((c) => c.id === 0).length) {
        this.table2.unshift({
          sgL_UsersID: this.fengjingItem.sgL_UsersId,
          sgL_DisplayName: this.fengjingItem.sgL_UsersName,
          sgL_StartTimeF: "",
          sgL_EndTimeF: "",
          id: 0,
        });
      }
    },
    stopOp(item) {
      if (item.stopDay) {
        this.$api.blog
          .AdminForbiddenCreate({
            id: item.id,
            sgL_UsersID: item.sgL_UsersID,
            sgL_EndTime: item.stopDay,
          })
          .then((res) => {
            if (res.data.success) {
              this.stopData(item.sgL_UsersID);
              this.$message.success(this.$t('message.operatesuccessfully'));
            } else {
              this.$message.error(res.data.error.message);
            }
          });
      }
    },
    getRecentDay(item, n) {
      let day = "";
      if (item.id === 0) {
        day = moment(new Date())
          .subtract(-n, "days")
          .format("YYYY-MM-DD HH:mm");
      } else {
        day = moment(new Date(item.sgL_StartTimeF))
          .subtract(-n, "days")
          .format("YYYY-MM-DD HH:mm");
      }
      return day;
    },
    stopChange(aaa, item) {
      let dt = new Date();
      if (aaa === 1) {
        dt = this.getRecentDay(item, 3);
      }
      if (aaa === 2) {
        dt = this.getRecentDay(item, 5);
      }
      if (aaa === 3) {
        dt = this.getRecentDay(item, 7);
      }
      if (aaa === 4) {
        dt = this.getRecentDay(item, 14);
      }
      if (aaa === 5) {
        dt = this.getRecentDay(item, 36500);
      }
      if (aaa === 6) {
        dt = moment().format("yyyy-MM-DD HH:mm");
      }
      item.stopDay = dt;
    },
    go1(item) {
      let routeData = this.$router.resolve({
        name: "blogUserInfo",
        query: { id: item.sgL_UsersId },
      });
      window.open(routeData.href, "_blank");
    },
    go2(id) {
      let routeData = this.$router.resolve({
        name: "blogDetail",
        query: { id },
      });
      window.open(routeData.href, "_blank");
    },
    show(id) {
      this.$api.blog.adminUpdateIsShow({ id }).then((res) => {
        this.GetEventList();
        this.$message.success(this.$t('message.operatesuccessfully'));
      });
    },
    async searchFengjing() {
      let params = {
        SkipCount: 0,
        MaxResultCount: 1,
        SGL_DisplayName: this.SGL_DisplayName,
      };
      const res = await this.$api.blog.AdminForbiddenGetAll(params);
      if (res.data.success) {
        this.table2 = res.data.result.items;
        this.pageParams2.total = res.data.result.totalCount;
      }
    },
    stopData(sgL_UsersId) {
      let params = {
        SkipCount: (this.pageParams2.currentPage - 1) * this.pageParams2.limit,
        MaxResultCount: this.pageParams2.limit,
        SGL_UsersID: sgL_UsersId,
      };
      this.$api.blog.AdminForbiddenGetAll(params).then((res) => {
        if (res.data.success) {
          this.table2 = res.data.result.items.map((item) => {
            if (item.id === 0) {
              item.sgL_StartTimeF = "";
              item.sgL_EndTimeF = "";
            }
            return item;
          });
          this.pageParams2.total = res.data.result.totalCount;
        }
      });
    },
    stop(item) {
      this.table2 = [];
      this.fengjingItem = item;
      this.stopData(item.sgL_UsersId);
      this.dialogVisible = true;
    },
    GetEventList() {
      let params = {
        SkipCount: (this.pageParams.currentPage - 1) * this.pageParams.limit,
        MaxResultCount: this.pageParams.limit,
        SGL_AddTimerDate: this.SGL_AddTimerDate,
        sgL_Name: this.SGL_DisplayName,
      };
      this.$api.blog.adminGetAll(params).then((res) => {
        if (res.data.success) {
          this.EventList = res.data.result.items;
          this.pageParams.total = res.data.result.totalCount;
        }
      });
    },
    //删除
    DeleteEvent(Id) {
      this.$confirm("確認刪除?", "提示", {
        confirmButtonText: "確定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          Id: Id,
        };
        this.$api.blog.adminDelete(params).then((result) => {
          if (result.data.success) {
            this.$message.success(this.$t('message.operatesuccessfully'));
          } else {
            Message({
              type: "warning",
              message: result.data.error.message,
            });
          }
          this.GetEventList();
        });
      });
    },
    edit(id) {
      let routeData = this.$router.resolve({
        name: "customerPublish",
        query: { editBlogId: id },
      });
      window.open(routeData.href, "_blank");
    },
    //分页的方法
    handleCurrentChange(val) {
      this.pageParams.currentPage = val;
      this.GetEventList();
    },
    handleSizeChange(val) {
      this.pageParams.limit = val;
      this.pageParams.currentPage = 1;
      this.GetEventList();
    },
    handleCurrentChange2(val) {
      this.pageParams2.currentPage = val;
      this.stopData();
    },
    handleSizeChange2(val) {
      this.pageParams2.limit = val;
      this.pageParams2.currentPage = 1;
      this.stopData();
    },
  },
  computed: {
    EventListModel() {
      return this.EventList;
    },
  },
};
</script>

<style scoped>
.ck:hover {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminBlog/index.vue